exports = module.exports = require("/home/kwok/projects/brewplanner/brewplanner-ui/node_modules/css-loader/cssToString.js")();
exports.push([module.id, ".bp-grid-item-filter{margin:-20px 0 30px 5px}", ""]);


/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/sass-loader!./src/components/Commons/GridItem/GridItemFilter.scss
 ** module id = 252
 ** module chunks = 0
 **/